import React from 'react'

export default function About() {
  return (
    <>
        <div id='about' className='md:px-10 px-2 max-w-screen-xl justify-center mx-auto items-center'>
            <div className='text-white mx-auto md:pt-72 md:pb-32 pt-10 justify-center items-center'>
                <div className='justify-center py-5 gap-16 items-center mx-auto'>
                    <div className='px-4'>
                        <h1 className='text-base font-semibold text-[#136690]'>
                            The Right Cybersecurity Services for Biopharma
                        </h1>
                        <h1 className='text-white md:text-4xl text-2xl justify-center pt-5 font-semibold'>
                            Meeting Biopharma Cybersecurity Challenges: <br/> A Holistic Prescription
                        </h1>
                        <p className='text-[#C3CDD3] pt-4 max-w-screen-lg'>
                            Healthcare organizations globally face a serious challenge when it comes to data security and compliance. Security controls
                            Implementation has always been complex and demands a lot from healthcare IT staff who lack the skills and resources to do it effectively.
                        </p>
                        <h1 className='md:text-xl text-xl font-semibold pt-8'>
                            Cybersecurity and Biopharma businesses
                        </h1>
                        <p className='pt-5 text-[#C3CDD3]  max-w-screen-lg'>
                            According to a recent study by Deloitte, suppliers in the biopharma sector are the top targets of cybercriminals worldwide.
                            Because these companies are moving towards increasing digitization and storing valuable data online. This sector has become the biggest target of cyber attacks. 
                            <br className='block md:hidden lg:hidden'/><br className='block md:hidden lg:hidden'/>
                            innovation an industry based on, with extensive investments in research and development (R&D) and intellectual property (IP) on medicines and patient health data;
                            has gone, bridging the divide between business and healthcare, which is becoming a hot spot in the health data risk landscape.
                        </p>
                        <h1 className='md:text-xl text-xl font-semibold pt-8'>
                            What should keep you up at night as a Biopharma leader?
                        </h1>
                        <p className='pt-5 text-[#C3CDD3]  max-w-screen-lg'>
                            Gaining visibility into a fragmented supply chain. To control what is happening, the assets, connections, communications, protocols,
                            And many more require real-time exposure.<br className='block md:hidden lg:hidden'/> <br className='block md:hidden lg:hidden'/>
                            Assessing risk in manufacturing environments.
                            Millions in productivity by being prepared for risks such as unplanned downtime
                            can result in loss and inventory problems that hurt the bottom line. <br className='block md:hidden lg:hidden'/><br className='block md:hidden lg:hidden'/>
                            Defending valuable corporate IP from cyber espionage. To protect the company's competitive position and reputation, BioPharma manufacturers
                            It is important for them to keep product development plans, research results and other confidential IP secrets well protected.
                            <br/><br/>
                            Detecting malware operating within IT/OT networks. Automated monitoring of pharma OT network to identify threats.
                            Adhere to consistent compliance requirements. Due to the complexity and variability of regulatory compliance, this is difficult to achieve
                            help you to do.
                        </p>
                        <h1 className='md:text-xl text-xl font-semibold pt-8'>
                            RockSec Group reduces cyber risk for Biopharma businesses.
                        </h1>
                        <p className='pt-5 text-[#C3CDD3]  max-w-screen-lg'>
                            The key is to focus efforts on identifying and protecting the most important information assets, which can be achieved by embedding good cyber behavior while
                            Minimize the business impact on any BioPharma business by improving breach detection and response capabilities.
                        </p>
                        <br/>
                        <p className='text-[#C3CDD3] text-sm md:pt-10'>
                            An effective approach should be consistent compliance Continuous Protection | Continuous visibility
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div className='bg-[#0D0D0D] w-full text-white md:pb-14 mt-10 md:mt-0'>
            <div className='pt-16 md:pt-44 max-w-screen-md mx-auto justify-center md:px-10 px-5'>
                <h1 className='md:text-5xl text-2xl text-center'>
                    How we help BioPharma stay secure & compliant?
                </h1>
                <p className='pt-5 md:pt-10 text-[#C3CDD3] md:max-w-screen-sm mx-auto justify-center text-center md:text-base text-sm'>
                    RockSec Group's World-class Cybersecurity services help Biopharma businesses comply with requirements, avoid costly fines and maintain reputation. 
                </p>
            </div>
        </div>
    </>
  )
}
